__webpack_require__.p = "https://certificate.quantstamp.com/full/strata-markets-update-isolated-and-saturn-strategies/13992bae-733d-47e0-ba79-d34ca72b36d1/";